<template>
  <modal ref="confirm" :width="500">
    <div class="confirmation-modal-text">
      You have unsaved changes on your target.
      Are you sure you would like to disregard your changes?
    </div>
    <div slot="actions">
      <action-button id="confirmSaveBtn" color="success" @click.native="cancelHandler" :label="saveButton" />
      <action-button id="confirmGoToDashboardBtn" color="light-blue lighten-1" @click.native="continueHandler" label="Continue to Dashboard" />
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/common/modal'
import ActionButton from '@/components/common/actionButton'
import { SAVE_TARGET } from '@/views/workbenchCanvas/store/WorkbenchWCanvasSlotActionsGenerator'
import { TARGET_TYPE, ACTIVATION_STATUS } from '@/appLogic/targets/Constants'
import { deleteTarget } from '@/api'

const SAVE = 'Save'
const KEEP_WORKING = 'Keep Working'

export default {
  components: {
    Modal,
    ActionButton
  },
  data () {
    return {
      next: null,
      saveButton: SAVE,
      continueWithoutSave: true
    }
  },
  computed: {
    currentTarget () {
      return this.$store.getters.currentTarget
    }
  },
  methods: {
    open (next) {
      if (next == null) {
        throw Error('You must pass the next function into this open function in order to continue on the route')
      }
      this.next = next
      this.$refs.confirm.open()
    },
    cancelHandler () {
      if (this.saveButton === SAVE) {
        this.saveButton = KEEP_WORKING
        this.$store.dispatch(SAVE_TARGET)
        this.continueWithoutSave = false
      } else {
        this.$refs.confirm.close()
      }
    },
    continueHandler () {
      if (this.continueWithoutSave && this.currentTarget.activation_status === ACTIVATION_STATUS.DRAFT) {
        deleteTarget(this.currentTarget).then(function (response) {
          console.log(response)
        }).catch(function (err) {
          console.log(err)
        })
      }
      this.next()
    }
  }
}
</script>

<style lang="scss">

</style>




// WEBPACK FOOTER //
// ConfirmModal.vue?e550dbca